import { Theme } from '@mui/material';

export const signatureProps = {
  sx: (theme: Theme) => ({
    color: theme.palette.black.dark,
    opacity: 0.54,
    fontWeight: 600,
    fontSize: 12,
  }),
};
